// src/App.js
import React from 'react';
import { Route, Routes } from 'react-router-dom';
import TopHeader from './components/TopHeader';
import Navbar from './components/Navbar';
import MercuryHeader from "./components/MercuryHeader";
import Footer from './components/Footer';
import Hero from './components/Hero';
import Home from './pages/Home'; // Import Home page
import About from './pages/About';
import Verses from './pages/Verses';
import VerseDetail from './pages/VerseDetail';
import Healing from './pages/Healing';
import Resources from './pages/Resources';
import Achievements from './pages/Achievements';
import Contact from './pages/Contact';
import Shlokas from './pages/Shlokas'; // ✅ Add this import
import CertificateGenerator from './pages/CertificateGenerator';


function App() {
  return (
    <>
      <TopHeader />
      <Navbar />
      <MercuryHeader />
      <Hero />
      <Routes>
        <Route path="/" element={<Home />} /> {/* Set Home as the default page */}
        <Route path="/about" element={<About />} />
        <Route path="/verses" element={<Verses />} />
        <Route path="/verse/:id" element={<VerseDetail />} />
        <Route path="/healing" element={<Healing />} />
        <Route path="/resources" element={<Resources />} />
          <Route path="/achievements" element={<Achievements />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/shlokas" element={<Shlokas />} /> {/* ✅ Added route */}
        <Route path="/certificate" element={<CertificateGenerator />} />

      </Routes>
      <Footer />
    </>
  );
}

export default App;
